const UNIVERSAL = {
  BASEURL: process.env.REACT_APP_API_URL,
};
export default UNIVERSAL;
